import DragAndDropHorizontal from '../DragAndDropHorizontal/DragAndDropHorizontal';
import ClassificationOption from '../ClassificationOption/ClassificationOption';
import GeneralOptionDrag from '../GeneralOptionDrag/GeneralOptionDrag';
import '../MultipleSelectQuiz/MultipleSelectQuiz.css';
import './SimpleApplication.css';
import '../../chaptercontainer.css';



import questionIcon from '../images/question.png';


const SimpleApplication = ({
  question,
  options = [],

  // simpleSelect
  selectedAnswer = null,
  onSelectAnswer,

  // multipleSelect
  selectedAnswers = [],
  onMultipleAnswersChange,

  // dragAndDropHorizontal
  dragAnswers = [],
  onDragAnswersChange,
  getOptionValueById,

  // classificationOption
  classificationAnswers = {},
  onClassificationAnswersChange,

  // generalOptionDrag
  generalDragAnswers = [],
  onGeneralDragAnswersChange,
  getGeneralOptionValueById,

  isAnswerChecked = false,



}) => {

  



  if (!question) {
    return null;
  }

 

  const applicationType =
    question.applicationType ||
    'simpleSelect';

  const safeSelectedAnswers =
    Array.isArray(selectedAnswers)
      ? selectedAnswers
      : [];

  const safeDragAnswers =
    Array.isArray(dragAnswers)
      ? dragAnswers
      : [];

  const safeGeneralDragAnswers =
    Array.isArray(generalDragAnswers)
      ? generalDragAnswers
      : [];

  const safeClassificationAnswers =
    classificationAnswers &&
    typeof classificationAnswers === 'object' &&
    !Array.isArray(classificationAnswers)
      ? classificationAnswers
      : {};

  
const handleSelectAnswer = (option) => {
  if (isAnswerChecked) {
    return;
  }

  // Daca apasam pe raspunsul deja selectat,
  // il deselectam.
  if (selectedAnswer === option) {
    onSelectAnswer?.(null);
    return;
  }

  // Altfel, selectam noul raspuns.
  onSelectAnswer?.(option);
};


const handleMultipleAnswer = (option) => {
  if (isAnswerChecked) {
    return;
  }

  onMultipleAnswersChange?.(option);
};

  const getSimpleOptionClassName = (
    option
  ) => {
    if (isAnswerChecked) {
      if (
        option ===
        question.correctAnswer
      ) {
        return 'simple-application-correct';
      }

      if (
        option === selectedAnswer
      ) {
        return 'simple-application-incorrect';
      }

      return 'simple-application-default';
    }

    if (
      selectedAnswer === option
    ) {
      return 'simple-application-selected';
    }

    return 'simple-application-default';
  };

  const getMultipleOptionClassName = (
    option
  ) => {
    const correctAnswers =
      Array.isArray(
        question.correctAnswer
      )
        ? question.correctAnswer
        : [];

    const isSelected =
      safeSelectedAnswers.includes(
        option
      );

    const isCorrect =
      correctAnswers.includes(option);

    if (isAnswerChecked) {
      if (isCorrect) {
        return 'simple-application-correct';
      }

      if (isSelected) {
        return 'simple-application-incorrect';
      }

      return 'simple-application-default';
    }

    if (isSelected) {
      return 'simple-application-selected';
    }

    return 'simple-application-default';
  };

  const renderSimpleSelect = () => (
    <div className="simple-application-buttons">
      {options.map(
        (option, index) => (
          <button
            key={`${String(option)}-${index}`}
            type="button"
            className={
              getSimpleOptionClassName(
                option
              )
            }
            disabled={isAnswerChecked}
            onClick={() =>
              handleSelectAnswer(option)
            }
          >
            <p>{String(option)}</p>
          </button>
        )
      )}
    </div>
  );

const renderMultipleSelect = () => {
  const correctAnswers =
    Array.isArray(
      question.correctAnswer
    )
      ? question.correctAnswer
      : [];

  return (
    <div className="multiple-answer-lessons-bc">
      {options.map(
        (option, index) => {
          const isSelected =
            safeSelectedAnswers.includes(
              option
            );

          const isCorrect =
            correctAnswers.includes(
              option
            );

          let checkboxClass =
            'check-box-multiple-answer-bc';

          if (isAnswerChecked) {
            if (isCorrect) {
              checkboxClass =
                'checkbox-correct';
            } else if (
              isSelected &&
              !isCorrect
            ) {
              checkboxClass =
                'checkbox-incorrect';
            }
          }

          const optionStateClass =
            isAnswerChecked
              ? isCorrect
                ? 'border-correct'
                : isSelected
                  ? 'border-incorrect'
                  : ''
              : isSelected
                ? 'border-selected'
                : '';

          return (
            <div
              key={`${String(option)}-${index}`}
              className={[
                'align-multiple-items-bc',
                optionStateClass,
              ]
                .filter(Boolean)
                .join(' ')}
              onClick={() =>
                handleMultipleAnswer(
                  option
                )
              }
              role="checkbox"
              aria-checked={
                isSelected
              }
              tabIndex={
                isAnswerChecked
                  ? -1
                  : 0
              }
              onKeyDown={(event) => {
                if (
                  event.key ===
                    'Enter' ||
                  event.key === ' '
                ) {
                  event.preventDefault();

                  handleMultipleAnswer(
                    option
                  );
                }
              }}
            >
              <input
                className={
                  checkboxClass
                }
                type="checkbox"
                checked={isSelected}
                readOnly
              />

              <span className="cursor-pointer">
                {String(option)}
              </span>
            </div>
          );
        }
      )}
    </div>
  );
};

const getHorizontalOptionValue = (
  option
) => {
  if (
    option &&
    typeof option === 'object'
  ) {
    return (
      option.code ??
      option.value ??
      option.label ??
      ''
    );
  }

  return option;
};

const getSlotsCount = () => {
  if (
    Number.isFinite(
      Number(question.slotsCount)
    ) &&
    Number(question.slotsCount) > 0
  ) {
    return Number(
      question.slotsCount
    );
  }

  if (
    Array.isArray(
      question.sentenceParts
    )
  ) {
    return question.sentenceParts.filter(
      (part) =>
        String(part) ===
        '__SLOT__'
    ).length;
  }

  return Array.isArray(
    question.correctAnswer
  )
    ? question.correctAnswer.length
    : 0;
};

const renderDragAndDropHorizontal =
  () => {
    const slotsCount =
      getSlotsCount();

    const expectedAnswers =
      Array.isArray(
        question.correctAnswer
      )
        ? question.correctAnswer.map(
            String
          )
        : [];

    const rows = [
      {
        label: '',
        slots: slotsCount,
      },
    ];

    const sentenceSegments =
      Array.isArray(
        question.sentenceParts
      )
        ? question.sentenceParts
        : [];

    return (
      <div className="simple-application-interaction">
        <DragAndDropHorizontal
          question={question}
          options={options}
          selectedAnswers={
            safeDragAnswers
          }
          isAnswerChecked={
            isAnswerChecked
          }

          slotsCount={
            slotsCount
          }
          expectedAnswers={
            expectedAnswers
          }
          rows={rows}
          sentenceSegments={
            sentenceSegments
          }

          getOptionValueById={
            getOptionValueById
          }

          onAnswersChange={
            onDragAnswersChange
          }

          showQuestion={false}
          showContext={false}
          insideSimpleApplication={true}
        />
      </div>
    );
  };

  const renderClassificationOption =
    () => (
        <div className="simple-application-interaction">
      <ClassificationOption
        question={question}
        categories={
          Array.isArray(
            question.categories
          )
            ? question.categories
            : []
        }
        options={options}
        answers={
          safeClassificationAnswers
        }
        isAnswerChecked={
          isAnswerChecked
        }
        onAnswersChange={
          onClassificationAnswersChange
        }
        showQuestion={false}
        showContext={false}
        useScrollWrapper={false}
      />
    </div>
    );

const renderGeneralOptionDrag =
  () => (
    <div className="simple-application-interaction">
      <GeneralOptionDrag
        question={question}
        options={options}
        answers={safeGeneralDragAnswers}
        isAnswerChecked={isAnswerChecked}
        onAnswersChange={onGeneralDragAnswersChange}
        getOptionValueById={getGeneralOptionValueById}
        showQuestion={false}
        insideSimpleApplication={true}
      />
    </div>
  );

  const renderApplicationContent = () => {
    switch (applicationType) {
      case 'multipleSelect':
        return renderMultipleSelect();

      case 'dragAndDropHorizontal':
        return renderDragAndDropHorizontal();

      case 'classificationOption':
        return renderClassificationOption();

      case 'generalOptionDrag':
        return renderGeneralOptionDrag();

      case 'simpleSelect':
      default:
        return renderSimpleSelect();
    }
  };

return (
<div
  className={[
    'quiz-content-scroll-bc',
    applicationType === 'classificationOption'
      ? 'classification-page-fixed-bc'
      : '',
  ]
    .filter(Boolean)
    .join(' ')}
>
    <div className="simple-application-container-bc">
      <div
        className={[
          'simple-application-instruction',
          applicationType === 'classificationOption'
            ? 'classification-instruction-fixed-bc'
            : '',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <div className="simple-application-content">


          {question.question && (
            <div className="simple-application-question">
              <img
                src={questionIcon}
                alt="Question"
                className="simple-application-question-icon"
              />

              <p>{question.question}</p>
            </div>
          )}

          {renderApplicationContent()}
        </div>
      </div>
    </div>
  </div>
);
};

export default SimpleApplication;